import { Grid, Typography } from '@mui/material'
import React from 'react'
import { RequirementStatus } from '../Common/FieldsForForms/RequirementStatus'

export const ContractTermination = ({ useFetchInit }) => {

  const { 
    //------------- Generales
    location,
    paramsURL,
    //------------- globalStates
    globalStates,
    //------------- FetchData
    FetchData,
    //------------- Actions
    Actions,
    //------------- helpers
    Helpers,
    //------------- Formularios
    Forms
    
  } = useFetchInit

  const {FormRequestGlobal: {formState}} = Forms

  return (
    <>
      <Typography sx={{mt:3,fontWeight: 'bold'}} variant='subtitle2'>
          Requisitos para la finalizacion de credito
      </Typography>
      <div className="border-bottom border-dark"></div>
      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{mb:4}}>

        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 1, mt: 2 }}>
          <RequirementStatus message = '1. El cliente debe estar solvente en su totalidad' requirement_status = {formState.check_requerimiento_solvent}/>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 1, mt: 2 }}>
          <RequirementStatus message = '2. El cliente debe de realizar el retiro de GPS' requirement_status = {formState.check_requerimiento_gps}/>
        </Grid>
        
        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 1, mt: 2 }}>
          <RequirementStatus message = '3. El cliente debe de haber cancelado la poliza de seguro' requirement_status = {formState.check_requerimiento_seguro}/>
        </Grid>
        
      </Grid>

    </>
  )
}